// @flow

import React from "react";
import { localize } from "redux-i18n";
import { formatDateTime, transformSecondsInHours } from "@transformers/date";
import { GSGrid, View, Text } from "@components";
import type { EmployeeAbsence } from "@modules/shared/reducer/employee-absences/types";

type Props = $Exact<{
  className?: string,
  absences: Array<EmployeeAbsence>,
  ...PropsFromLocalize,
}>;

class ExportAbsenceHistory extends React.Component<Props> {
  get columnsConfig() {
    return [
      {
        key: "id",
        name: this.props.t("ABSENCE_ID"),
      },
      {
        key: "startsAt",
        name: this.props.t("START"),
        renderCell: ({ row }: Object) => formatDateTime(row.startsAt),
      },
      {
        key: "fitAt",
        name: this.props.t("FIT_DATE"),
        renderCell: ({ row }: Object) => formatDateTime(row.fitAt),
      },
      {
        key: "rtwAt",
        name: this.props.t("RTW_DATE"),
        renderCell: ({ row }: Object) => formatDateTime(row.rtwAt),
      },
      {
        key: "workingTimeLostInSeconds",
        name: this.props.t("HOURS_LOST"),
        renderCell: ({ row }: Object) => transformSecondsInHours(row.workingTimeLostInSeconds),
      },
      {
        key: "workingDaysLost",
        name: this.props.t("WORKING_DAYS"),
      },
      {
        key: "absenceType",
        name: this.props.t("ABSENCE_TYPE"),
        renderCell: ({ row }: Object) => this.props.t(row.absenceType || ""),
        align: "left",
      },
      {
        key: "absenceReason",
        name: this.props.t("ABSENCE_REASON_CLASSIFICATION"),
        renderCell: ({ row }: Object) => row.absenceReason.name || this.props.t("CONSENT_WITHHELD"),
        align: "left",
      },
    ];
  }

  render() {
    return (
      <View className={this.props.className} gap={3}>
        <Text type="h5" text={this.props.t("HISTORY")} />
        <GSGrid columns={this.columnsConfig} rows={this.props.absences} />
      </View>
    );
  }
}

export default localize()(ExportAbsenceHistory);
